import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const FAQIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
		<path fill="#9E76D1" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Z" opacity=".2" />
		<path
			fill="#9E76D1"
			d="M10 5.75c-.621 0-1.125.504-1.125 1.125a.75.75 0 0 1-1.5 0 2.625 2.625 0 1 1 4.508 1.829c-.092.095-.18.183-.264.267-.203.193-.394.4-.571.617-.22.282-.298.489-.298.662V11a.75.75 0 1 1-1.5 0v-.75c0-.655.305-1.186.614-1.583.229-.294.516-.58.75-.814.07-.07.136-.135.193-.194A1.125 1.125 0 0 0 10 5.749ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
		/>
	</svg>
);
